/**
 * Track Type Configuration Component Registry
 *
 * Maps track types to their configuration components.
 * These components are rendered in the TrackBuilder's Agent Config tab
 * to provide type-specific configuration UI.
 */

import AssessmentConfig from './AssessmentConfig';
import EducationConfig from './EducationConfig';
import SkillBuildingConfig from './SkillBuildingConfig';
import ActivityConfig from './ActivityConfig';
import ContentGroupsConfig from './ContentGroupsConfig';

const CONFIG_COMPONENTS = {
  assessment: AssessmentConfig,
  education: EducationConfig,
  skill_building: SkillBuildingConfig,
  activity: ActivityConfig,
  // On-demand pathway types share the content-groups selector
  information: ContentGroupsConfig,
  resource_finder: ContentGroupsConfig
};

/**
 * Get the configuration component for a track type
 * @param {string} trackType - The track type code
 * @returns {React.Component|null} The config component or null
 */
export function getConfigComponent(trackType) {
  return CONFIG_COMPONENTS[trackType] || null;
}

/**
 * Check if a track type has a configuration component
 * @param {string} trackType - The track type code
 * @returns {boolean} True if component exists
 */
export function hasConfigComponent(trackType) {
  return trackType in CONFIG_COMPONENTS;
}

export default CONFIG_COMPONENTS;
